import React, { useContext } from 'react';
const MainContext = React.createContext({
  isPreview: false,
  hasGTM: false
});
const MainContextProvider = MainContext.Provider;
const MainContextConsumer = MainContext.Consumer;
const AppContext = React.createContext({});
const AppContextProvider = AppContext.Provider;
const AppContextConsumer = AppContext.Consumer;
const useMainContext = () => useContext(MainContext);
export { MainContext, MainContextProvider, MainContextConsumer, useMainContext, AppContext, AppContextProvider, AppContextConsumer };
//# sourceMappingURL=index.js.map